// import { useEffect, useState } from 'react'

// const useCountdown = (props) => {
//   const { initialMinute = 0, initialSeconds = 0 } = props
//   const [minutes, setMinutes] = useState(initialMinute)
//   const [seconds, setSeconds] = useState(initialSeconds)
//   const [isStop, setIsStop] = useState(false)
//   useEffect(() => {
//     let myInterval = setInterval(() => {
//       if (seconds > 0) {
//         setSeconds(seconds - 1)
//       }
//       if (seconds === 0) {
//         if (minutes === 0) {
//           setIsStop(true)
//           clearInterval(myInterval)
//         } else {
//           setMinutes(minutes - 1)
//           setSeconds(59)
//         }
//       }
//     }, 1000)
//     return () => {
//       clearInterval(myInterval)
//     }
//   })
//   return [minutes, seconds, isStop]
// }

// export { useCountdown }

import { useEffect, useState } from 'react'

const useCountdown = (props) => {
  const { initialMinute = 0, initialSeconds = 0, freeze = false } = props
  const [minutes, setMinutes] = useState(initialMinute)
  const [seconds, setSeconds] = useState(initialSeconds)
  const [isStop, setIsStop] = useState(false)
  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds((prev) => (freeze ? prev : prev - 1))
      }
      if (seconds === 0) {
        if (minutes === 0) {
          setIsStop(true)
          clearInterval(myInterval)
        } else {
          setMinutes((prev) => prev - 1)
          setSeconds(59)
        }
      }
    }, 1000)

    return () => clearInterval(myInterval)
  }, [seconds, minutes, freeze])

  return [minutes, seconds, isStop]
}

export { useCountdown }
